import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AuthenticationFacade } from './+state';
import { AuthenticationStateModule } from './+state/authentication.state.module';
import {
  AnonymousUserGuard,
  AuthenticationTokenGuard,
  CompanyGroupGuard,
  CompanyServiceEndedGuard,
  CompanyTokenNotExistGuard,
  GuestCheckoutGuard,
  LocationTokenGuard,
  UnAuthenticationTokenGuard,
} from './guards';
import { TokenValidationGuard } from './guards/token-validation.guard';
import { HandlerChainService } from './handlers';
import { AuthenticationTokenProvider } from './providers';
import {
  AccountDetailsService,
  AuthenticationService,
  HashService,
  RefreshTokenService,
  ResetPasswordService,
  ValidationEmailService,
  AccountService,
} from './services';
import { ValidateUserGuard } from './guards/validate-user.guard';
import { ServiceEndedGuard } from './guards/service-ended.gaurd';
import { ScanQRUserGuard } from './guards/scan-qr-user.guard';

@NgModule({
  imports: [CommonModule, AuthenticationStateModule],
})
export class DomainAuthenticationModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainAuthenticationModule,
      providers: [
        AuthenticationService,
        HashService,
        HandlerChainService,
        AccountDetailsService,
        AuthenticationFacade,
        AuthenticationTokenGuard,
        UnAuthenticationTokenGuard,
        AnonymousUserGuard,
        ValidateUserGuard,
        ScanQRUserGuard,
        CompanyTokenNotExistGuard,
        CompanyServiceEndedGuard,
        LocationTokenGuard,
        AuthenticationTokenProvider,
        TokenValidationGuard,
        RefreshTokenService,
        ValidationEmailService,
        ResetPasswordService,
        AccountService,
        CompanyGroupGuard,
        ServiceEndedGuard,
        GuestCheckoutGuard,
      ],
    };
  }
}
